import { createSlice } from "@reduxjs/toolkit";


// 임시적으로 redux를 활용하여 말풍선 다시 보지 않기 boolean 상태를 관리 -> 추후 백엔드 api 를 통해 반영 예정
export interface iAssistantDockState {
  calloutHidden: boolean;
}

const assistantDockState: iAssistantDockState = {
  calloutHidden: false,
};

export const assistantDockSlice = createSlice({
  name: "assistantDock",
  initialState: assistantDockState,
  reducers: {
    hideCallout: (state) => {
      state.calloutHidden = true;
    },
    showCallout: (state) => {
      state.calloutHidden = false;
    },
  },
});

export const { hideCallout, showCallout } = assistantDockSlice.actions;

export default assistantDockSlice.reducer;
